export default {
  env: 'test'
}